import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import { mixpanel } from '../../lib/mixpanel';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminUserDetail from './AdminUserDetail';
import AdminPayments from './AdminPayments';
import AdminGenerations from './AdminGenerations';
import AdminPricing from './AdminPricing';

const NAV_ITEMS = [
  { label: 'Dashboard',   to: '/admin',             end: true },
  { label: 'Users',       to: '/admin/users',        end: false },
  { label: 'Payments',    to: '/admin/payments',     end: false },
  { label: 'Generations', to: '/admin/generations',  end: false },
  { label: 'Pricing',     to: '/admin/pricing',       end: false },
];

function AdminNav({ open, onNavigate }: { open: boolean; onNavigate: () => void }) {
  const navigate = useNavigate();
  return (
    <aside className={`admin-sidebar${open ? ' open' : ''}`}>
      <div className="admin-sidebar-brand">
        <h2>Mission Control</h2>
        <span>Admin</span>
      </div>
      <nav>
        {NAV_ITEMS.map(({ label, to, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            onClick={onNavigate}
            className={({ isActive }) =>
              `admin-nav-item${isActive ? ' active' : ''}`
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="admin-sidebar-footer">
        <button
          className="btn-ghost"
          style={{ width: '100%', textAlign: 'left', fontSize: '0.875rem' }}
          onClick={() => {
            onNavigate();
            navigate('/home');
          }}
        >
          ← Back to App
        </button>
      </div>
    </aside>
  );
}

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  // Admin usage is internal — stop Mixpanel session replay when entering /admin.
  useEffect(() => { mixpanel.stopSessionRecording(); }, []);

  return (
    <div className="admin-shell">
      <div className="admin-mobile-header">
        <button
          type="button"
          className="admin-hamburger"
          aria-label="Toggle navigation"
          aria-expanded={sidebarOpen}
          onClick={() => setSidebarOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
        <span className="admin-mobile-title">Mission Control</span>
      </div>

      {sidebarOpen && (
        <div className="admin-sidebar-backdrop" onClick={closeSidebar} />
      )}

      <AdminNav open={sidebarOpen} onNavigate={closeSidebar} />

      <main className="admin-main">
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="users/:id" element={<AdminUserDetail />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="generations" element={<AdminGenerations />} />
          <Route path="pricing" element={<AdminPricing />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default AdminLayout;
